import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'

import styles from './disclaimer.module.scss'

const Disclaimer = (props: any) => {
  const product = 'bundle' in props ? props.bundle : props.product
  return (
    product?.disclaimer && (
      <div
        className={styles.disclaimerBox}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: getSanitizedHtml(product?.disclaimer) ?? '',
        }}
      />
    )
  )
}

export default Disclaimer
